import React from "react"
import MotionProvider from "./src/components/shared/MotionProvider"
import { installCtaClickTracking, loadAnalytics, primeAnalytics, trackPageView } from "./src/utils/analytics"
import { onFirstInteraction } from "./src/utils/defer"

// Only truly global stylesheets belong here — anything imported from
// gatsby-browser lands in the shared styles bundle that every page must
// download. Route-specific systems are imported by the components that own
// them, so webpack ships them as their own chunk:
//   src/styles/feature-pages.css -> src/components/features/kit.tsx (+ pages using `.fp-*`)
//   src/styles/tool-pages.css    -> src/components/tools/ToolShell.tsx (+ pages using `.tool-*`)
import "./src/styles/global.css"
import "./src/styles/landing.css"

// How long a visitor can sit still before analytics loads anyway. Anything
// shorter lands inside the LCP window and measurably costs performance;
// anything longer risks missing very short, interaction-free visits.
const ANALYTICS_FALLBACK_MS = 5000

// The dataLayer shim is installed immediately (no network), so gtag() calls
// made by components before the vendor script lands are queued, not dropped.
export const onClientEntry = () => {
  primeAnalytics()
  // One delegated listener reports every `[data-cta]` click as `cta_click`.
  installCtaClickTracking()
  onFirstInteraction(loadAnalytics, ANALYTICS_FALLBACK_MS)
}

// The first page view ships with gtag's `config` call, so only report the
// client-side navigations that follow it.
let firstRoute = true

export const onRouteUpdate = ({ location }) => {
  if (firstRoute) {
    firstRoute = false
    return
  }
  trackPageView(location.pathname + location.search)
}

// framer-motion feature bundle, provided once for the whole app so components
// can use the lightweight `m.*` primitives. See shared/MotionProvider.
export const wrapRootElement = ({ element }) => <MotionProvider>{element}</MotionProvider>
